module.exports = __webpack_public_path__ + "img/Batara Finance.98255fe6.png";